import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedYoutubeCategories from './viewRelatedYoutubeCategories';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'General',
  attributeName:'Content-general-values',
  fields: [
    {
      attributeName: 'id',
      helpText: 'Id of the Interactable.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      placeholder: 'Interactable id...',
      hidden:true
    },
    {
      attributeName: 'name',
      helpText: 'Title of the interactable.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Interactable name...',
    },
    {
      attributeName: 'size',
      helpText: 'Select how the interactable is shown',
      type: FormInputTypes.SELECT,
      label: 'Interactable Size',
      placeholder: 'Interactable size...',
      options: [
        { name: 'XXL', value: 'xxl'},
        { name: 'XLV', value: 'xlv' },
      ],
    },
    {
      attributeName: 'orderItems',
      helpText: 'Select how the interactable order the items',
      type: FormInputTypes.SELECT,
      label: 'Order Items',
      placeholder: 'Order items...',
      options: [
        { name: 'Recent', value: 'recent'},
        { name: 'Most viewed', value: 'mostViewed' },
        { name: 'Closest to now', value: 'closestToNow' },
      ],
    },
    {
      attributeName: 'displayCategories',
      helpText: 'This checkbox is for the display of the categories at the top of the interactable.',
      type: FormInputTypes.CHECKBOX,
      label: 'Display Categories',
      default: true,
    },
    {
      attributeName: 'headerImageId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Header Image',
      helpText: 'Image of the header.',
      placeholder: 'Image...',
      fileType: ['image/*'],
      canUpdate:false,
      hasSelect:false,
      visibleWhen: [{"field":"displayCategories","notValue":true}]
    },
     {
      attributeName: 'contentType',
      helpText: 'Select how type of contents in the interactable',
      type: FormInputTypes.SELECT,
      label: 'Content Type',
      placeholder: 'Content type...',
      options: [
        { name: 'All', value: 'all'},
        { name: 'Live', value: 'live' },
        { name: 'VOD', value: 'vod' },
      ],
    },
    

    {
      attributeName: 'youtube_categories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedYoutubeCategories,
      default: [],
      helpText: 'Youtube categories joined.',
    },

    {
      attributeName: 'visible',
      helpText: 'This checkbox is for the display of the interactable or not.',
      type: FormInputTypes.CHECKBOX,
      label: 'Visible',
      default: true,
    },
     {
      attributeName: 'filters',
      helpText: '[{"id": "sortBy", "title": "SORT BY", "options": [{"id": "recent", "title": "Recent"}, {"id": "mostViewed", "title": "Most Viewed"}, {"id": "mostLiked", "title": "Top Rated"}]}]',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Filters',
      placeholder: 'Interactable name...',
    },
    {
      attributeName: 'filtersExampleText',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'Filters example text...',
      label:"Filter example text",
      default:'[{"id": "sortBy", "title": "SORT BY", "options": [{"id": "recent", "title": "Recent"}, {"id": "mostViewed", "title": "Most Viewed"}, {"id": "mostLiked", "title": "Top Rated"}]}]',
      required: true,
      errorText: '',
      disabled:true,
      classCssLabel:'form-show-text__bold'
    },


  ],
};
